<template>
  <div class="gs-app gm-dashboard-stats w-full flex lg:flex-wrap flex-col sm:flex-row gap-4 lg:gap-0 mb-5 lg:mb-0">
    <div
      v-for="stat in dashStatsData"
      :key="stat.id"
      class="flex sm:w-1/3 lg:w-1/2 lg:flex-wrap lg:mb-4 lg:pr-4"
    >
      <div
        class="w-full btn-radius bg-white gm-dashboard-stats__card"
      >
        <div class="text-deep-dark p-5 gm-dashboard-stats__title">
          {{ stat.title }}
        </div>
        <div
          v-if="stat && stat.hasLoaded"
          class="flex-1 text-deep-dark text-2xl font-bold p-5 pt-1"
        >
          {{ stat.value || 0 }}
        </div>
        <div class="flex-1 pb-6 pl-2" v-else>
          <countContentLoader />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countContentLoader from '@/components/content-loader/countcontentloader';

export default {
  name: 'DahboardStatsTabs',

  props: {
    dashStatsData: {
      required: true
    }
  },

  components: {
    countContentLoader
  }
};
</script>

<style scoped>
.gm-dashboard-stats__card {
  overflow: hidden;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gm-dashboard-stats__title {
  color: var(--gs-foreground);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.35;
}
</style>
